/* =========================================================================
   aw-v2-buy.js — zone d'achat de la fiche produit.

   POURQUOI CE FICHIER EXISTE
   Le bundle prakt (assets/app.js, sources absentes) porte une classe de
   gestion des variantes qui ne s'initialise jamais. Sa garde
   `get_data.length > 0` échoue à la construction, si bien que
   `selected_options` n'est jamais affecté. Or le gestionnaire du bouton
   « Ajouter au panier », lui, s'attache bien — et la première chose qu'il
   fait est de déréférencer ce binding. Au clic, la console affiche :

       Uncaught ReferenceError: Cannot access 'Br' before initialization

   C'est une zone morte temporelle (un `const`/`let` du bundle référencé
   avant son initialisation). Conséquences observées sur le thème LIVE comme
   sur le dev, sur une fiche 3 options comme sur une fiche 2 options :
     — cliquer une option ne fait rien : ni sélection, ni prix, ni variante ;
     — cliquer « Ajouter au panier » ne fait rien : le panier reste vide ;
     — le prix affiché est le minimum catalogue, pas celui de la variante.
   Seul le paiement express, natif Shopify, permettait encore d'acheter — sur
   la variante par défaut uniquement.

   Ce fichier reprend donc la logique d'achat à son compte, sans rien attendre
   du bundle. Il est VOLONTAIREMENT séparé de aw-v2-product.js : celui-ci
   porte les comportements des sections v2 (supports, atelier, sélection),
   qui n'ont rien à voir avec l'achat et n'ont pas à partir en correctif.

   CE QU'IL NE FAIT PAS
   Il ne touche ni au zoom, ni aux tiroirs, ni au panneau panier. Le contrat
   `.related_products` de aw-v2-selection n'est pas concerné.
   ⚠️ Ne pas lire cette ligne comme « ces parties fonctionnent » : c'est ce que
   disait la version precedente de cet en-tete, et c'est faux. Mesure du 17/09,
   sur la page LIVE servie telle quelle avec son app.js d'origine : le clic sur
   une image N'OUVRE PAS le zoom (opacite 0 avant comme apres). Le defaut est
   ANTERIEUR a ce fichier et n'est pas de son ressort — mais il est reel, et le
   supposer repare ferait perdre du temps au prochain qui passera.

   ---------------------------------------------------------------------------
   GALERIE LIEE A LA VARIANTE (2026-09-17)

   La classe variantes d'app.js etant morte (voir plus haut), plus rien ne
   faisait defiler la galerie vers le media de la variante choisie : changer
   « Cadre » ne changeait pas l'image. La DONNEE etait bonne — verifiee sur la
   fiche « quatre races de poules », dont les 49 variantes portent leur media
   cote Shopify, a la fois dans `variant.media` et dans `variant.image`.
   Personne ne la lisait, voila tout.

   ON NE PASSE PAS PAR app.js. Son point d'entree serait le clic sur vignette,
   qui appelle `carouselSlide()`. Mais celui-ci fait AUSSI
   `scrollToImage(carousel_container)`, qui scrolle LA PAGE jusqu'a la galerie.
   Declenche a chaque changement d'option, cela arracherait l'internaute des
   boutons qu'il utilise — sur mobile, ou la galerie est au-dessus des options,
   il remonterait a chaque touche. gsap est empaquete dans le bundle et n'est
   expose nulle part (pas de `window.gsap`), donc on ne peut pas tuer cette
   seule animation. On deplace donc la galerie nous-memes.

   CE QUE LA MESURE A MONTRE EN PASSANT : la classe carrousel d'app.js est morte
   elle aussi, exactement comme sa classe variantes. Sur la page LIVE d'origine,
   un clic sur une vignette ne deplace PAS la galerie (scrollLeft reste a 0), les
   fleches `.nav` ne sont jamais creees, et la galerie ne s'aligne pas au
   chargement. Reprendre vignettes et fleches ci-dessous ne retire donc rien qui
   marchait : cela repare. Les vignettes deviennent cliquables pour la premiere
   fois.

   ON REPREND AUSSI LES FLECHES ET LES VIGNETTES. Les fleches d'app.js avancent
   depuis SON compteur interne, inaccessible de l'exterieur. Deplacer la galerie
   sans le lui dire le laisse a zero : apres un changement de variante affichant
   l'image 3, un clic sur « suivant » porterait son compteur de 0 a 1 et la
   galerie RECULERAIT de 3 a 1. Corriger un defaut en en introduisant un autre
   n'est pas corriger. La navigation a donc un seul proprietaire — ce fichier.
   app.js garde le zoom, declenche par le clic sur `.item`, qui ne partage aucun
   etat avec la position du carrousel.
   ========================================================================= */
(function () {
  'use strict';

  function demarrer() {
    var liste = document.querySelector('.variant_list');
    if (!liste) return;

    var groupes = Array.prototype.slice.call(document.querySelectorAll('.variant_group'))
      .sort(function (a, b) { return Number(a.dataset.id) - Number(b.dataset.id); });
    if (!groupes.length) return;

    /* Les variantes viennent des <span> de données rendus par aw-product.liquid.
       On lit des attributs par option (data-o1/2/3) plutôt que de découper
       `variant.title` sur « / » : une valeur d'option contenant une barre
       oblique casserait silencieusement le découpage, et c'est le chemin
       d'achat qui en dépendrait. */
    var variantes = Array.prototype.slice.call(liste.querySelectorAll('.aw-variant')).map(function (s) {
      return {
        id: s.dataset.id,
        o: [s.dataset.o1 || '', s.dataset.o2 || '', s.dataset.o3 || ''],
        prix: s.dataset.prix || '',
        compare: s.dataset.compare || '',
        remise: s.dataset.remise || '',
        dispo: s.dataset.dispo === '1',
        /* `data-image` est deja rendu par aw-product.liquid — le meme drop
           Liquid que celui des <img> de la galerie, donc la meme URL de CDN
           des deux cotes. Aucun changement de gabarit n'a ete necessaire. */
        image: s.dataset.image || ''
      };
    });
    if (!variantes.length) return;

    var nb = groupes.length;
    var selection = [];
    var bouton = document.querySelector('#AddToCart');

    /* Le groupe « support » est repere par son data-role, pose par le Liquid
       d'apres le NOM de l'option — pas par sa position. Toutes les fiches n'ont
       pas trois options, et l'ancienne « Deco metal carte monde » n'en a que
       deux. Si aucun groupe ne porte ce role, on renonce simplement au title
       explicatif plutot que de nommer un support au hasard. */
    var rangSupport = -1;
    for (var gs = 0; gs < nb; gs++) {
      if (groupes[gs].dataset.role === 'support') { rangSupport = gs; break; }
    }

    var libelleBase = bouton ? bouton.textContent.trim() : '';
    var libelleAchat = libelleBase;

    function boutonsDe(g) {
      return Array.prototype.slice.call(groupes[g].querySelectorAll('.variant_button'));
    }

    /* Une valeur est proposable s'il existe au moins une variante DISPONIBLE
       qui la porte, compte tenu des choix déjà faits à sa gauche. Cascade de
       gauche à droite : en avançant, on ne tombe jamais sur un cul-de-sac. */
    function possible(g, valeur) {
      for (var k = 0; k < variantes.length; k++) {
        var v = variantes[k];
        if (!v.dispo || v.o[g] !== valeur) continue;
        var ok = true;
        for (var i = 0; i < g; i++) {
          if (selection[i] && v.o[i] !== selection[i]) { ok = false; break; }
        }
        if (ok) return true;
      }
      return false;
    }

    function resoudre() {
      for (var i = 0; i < nb; i++) if (!selection[i]) return null;
      for (var k = 0; k < variantes.length; k++) {
        var v = variantes[k], ok = true;
        for (var j = 0; j < nb; j++) if (v.o[j] !== selection[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }

    /* Après un changement à gauche, une valeur choisie à droite peut être
       devenue impossible. On la remplace par la première valeur encore
       proposable, plutôt que de laisser l'internaute devant un formulaire
       incohérent qui refuserait l'ajout sans dire pourquoi. */
    function reparer(depuis) {
      for (var i = depuis; i < nb; i++) {
        if (selection[i] && possible(i, selection[i])) continue;
        var libres = boutonsDe(i).filter(function (b) { return possible(i, b.dataset.value); });
        selection[i] = libres.length ? libres[0].dataset.value : null;
      }
    }

    function peindre() {
      for (var g = 0; g < nb; g++) {
        // forEach est synchrone : `rang` et `courant` valent bien ce qu'il faut
        // au moment de l'appel, sans avoir à jouer avec le `this` du callback.
        var rang = g;
        var courant = selection[g];
        var libres = [];
        boutonsDe(g).forEach(function (b) {
          var val = b.dataset.value;
          var off = !possible(rang, val);
          var coche = courant === val;
          b.classList.toggle('disabled', off);
          b.classList.toggle('active', coche);
          b.setAttribute('aria-disabled', off ? 'true' : 'false');
          b.setAttribute('aria-checked', coche ? 'true' : 'false');

          /* Dire POURQUOI une valeur est grisee. « Non disponible » tout court
             laisse l'internaute chercher ; nommer le support en cause lui dit
             quoi changer. */
          if (off && rangSupport > -1 && rang !== rangSupport && selection[rangSupport]) {
            b.setAttribute('title', 'Non disponible en ' + selection[rangSupport]);
          } else {
            b.removeAttribute('title');
          }

          if (!off) libres.push(b);
          b.tabIndex = -1;
        });

        /* Un seul point d'entree au clavier par groupe : la valeur cochee, ou
           a defaut la premiere encore proposable. C'est ce qu'attend le motif
           « radiogroup » — Tab traverse les groupes, les fleches parcourent
           les valeurs d'un groupe. */
        var entree = libres.filter(function (b) { return b.classList.contains('active'); })[0] || libres[0];
        if (entree) entree.tabIndex = 0;
      }
    }

    function majPrix(v) {
      var bloc = document.querySelector('.price_container');
      if (!bloc || !v) return;
      var fin = bloc.querySelector('.price .final');
      var comp = bloc.querySelector('.compare_at_price');
      var rem = bloc.querySelector('.discount');
      if (fin) fin.textContent = v.prix;
      if (comp) { comp.textContent = v.compare; comp.hidden = !v.compare; }
      if (rem) { rem.textContent = v.remise ? '-' + v.remise + '%' : ''; rem.hidden = !v.remise; }
      if (v.prix) bloc.setAttribute('data-price', v.prix);
    }

    function majFormulaire(v) {
      var cache = document.querySelector('#variant_id');
      var select = document.querySelector('#variant_selector');
      if (cache) cache.value = v ? v.id : '';
      if (select && v) select.value = v.id;
    }

    /* ---------- Galerie ----------
       Le carrousel est un scroller natif dans les deux cas : `overflow-x:scroll`
       + `scroll-snap` sur mobile (items a 90 %, alignes au centre),
       `overflow:hidden` sur desktop (items pleine largeur). Dans les deux cas on
       le deplace en ecrivant `scrollLeft` — aucune transformation a reproduire. */
    var galerie = (function () {
      var boite = document.querySelector('.main_product_container .image_section .carousel_container');
      if (!boite) return null;
      var items = Array.prototype.slice.call(boite.querySelectorAll('.item'));
      if (items.length < 2) return null;          // une seule image : rien a faire defiler
      var vignettes = Array.prototype.slice.call(document.querySelectorAll(
        '.main_product_container .image_section .thumbnail_container .thumb_item'));

      /* Rapprochement par URL de media. On normalise avant de comparer : le
         protocole peut manquer (`//cdn.shopify.com/...`) et le parametre `?v=`
         n'est pas garanti identique entre deux rendus du meme drop. */
      function cle(url) {
        return String(url || '').split('?')[0].replace(/^https?:/, '');
      }

      var rangParSource = {};
      items.forEach(function (it, rang) {
        var img = it.querySelector('img');
        var k = cle(img && img.dataset.image);
        if (k && !(k in rangParSource)) rangParSource[k] = rang;
      });

      function marquer(rang) {
        if (!vignettes.length) return;
        /* On retire la classe de TOUTES les vignettes, pas seulement de la
           precedente : app.js tient sa propre reference `last_active_thumb`,
           qu'on ne peut pas mettre a jour. En repartant de zero, l'affichage
           reste juste meme si le bundle intervient encore, au lieu de laisser
           deux vignettes actives. */
        vignettes.forEach(function (t) { t.classList.remove('active'); });
        if (vignettes[rang]) vignettes[rang].classList.add('active');
      }

      return {
        total: items.length,
        rangDe: function (url) {
          var k = cle(url);
          return k && (k in rangParSource) ? rangParSource[k] : -1;
        },
        aller: function (rang) {
          var it = items[rang];
          if (!it) return;
          /* Position CENTREE, et non alignee a gauche : les items mobiles font
             90 % de large avec `scroll-snap-align:center`. Viser le bord gauche
             provoquerait une correction visible juste apres, au moment ou le
             navigateur applique l'accrochage. Sur desktop les items font 100 %,
             donc centrer revient a aligner — la meme formule sert aux deux. */
          var dx = it.getBoundingClientRect().left - boite.getBoundingClientRect().left;
          var cible = boite.scrollLeft + dx - (boite.clientWidth - it.clientWidth) / 2;
          cible = Math.max(0, Math.min(cible, boite.scrollWidth - boite.clientWidth));
          marquer(rang);
          if (Math.abs(cible - boite.scrollLeft) < 1) return;
          /* ⚠️ DEPLACEMENT INSTANTANE, ET NON ANIME. `scrollTo({behavior:'smooth'})`
             NE FAIT RIEN sur ce conteneur — mesure faite sur la fiche reelle :
             depuis scrollLeft 1600, `smooth` laisse 1600, `auto` et l'affectation
             directe donnent bien 800. En cause, l'`overflow:hidden` pose par
             app.css au-dessus de 768,1 px : le navigateur refuse d'animer un
             scroller que l'internaute ne peut pas manipuler, alors qu'il accepte
             le saut. Une version « smooth » aurait donc marche sur mobile et
             silencieusement rien fait sur desktop.
             Le saut est de toute facon le bon comportement ici : choisir un cadre
             doit changer l'image, pas jouer une transition. */
          boite.scrollLeft = cible;
        }
      };
    })();

    var rangGalerie = -1;

    function majGalerie(v) {
      if (!galerie || !v) return;
      var rang = galerie.rangDe(v.image);
      if (rang < 0) return;                  // variante sans media : on laisse en place
      /* On ne court-circuite PAS sur `rang === rangGalerie`. Sur mobile le
         carrousel se fait glisser au doigt, sans que rien ne nous en previenne :
         le rang memorise serait alors faux, et un changement d'option vers ce
         rang-la ne ramenerait pas la galerie. C'est `aller()` qui tranche, en
         comparant a la position REELLE du scroller. */
      /* Le rang a-t-il vraiment change ? C'est la seule question qui decide du
         rappel a l'ecran plus bas. Un changement de FORMAT ne change pas
         l'image : il ne doit donc rien faire bouger. */
      var nouvelleImage = rang !== rangGalerie;
      rangGalerie = rang;
      galerie.aller(rang);
      if (nouvelleImage) ramenerGalerie();
    }

    /* ---------- MOBILE : ramener la galerie sous les yeux ----------
       En mobile la galerie est au-dessus des selecteurs. Choisir « Toile » ou
       « cadre noir » change l'image — mais l'image est alors hors de l'ecran,
       et l'internaute ne voit rien de ce qu'il vient de choisir. On la ramene.

       QUATRE GARDE-FOUS, tous necessaires :
       — mobile seulement (< 820 px). En desktop la galerie est a cote, deja
         visible : la faire defiler serait un mouvement gratuit ;
       — seulement si elle est MAJORITAIREMENT hors champ. Si on en voit deja
         la moitie, le changement se remarque sans rien bouger ;
       — jamais au chargement. `rafraichir()` est appele une premiere fois a
         l'init pour peindre l'etat de depart : sans ce verrou, la page
         sauterait toute seule a l'arrivee ;
       — `prefers-reduced-motion` annule tout. Pas un defilement instantane a
         la place : quelqu'un qui demande moins de mouvement ne demande pas un
         saut brutal, il demande qu'on le laisse tranquille.

       Le delai laisse au navigateur le temps d'appliquer le changement
       d'image avant de le montrer : defiler vers une galerie qui n'a pas
       encore bascule reviendrait a exhiber l'ancienne. */
    var premierRendu = true;

    function ramenerGalerie() {
      if (premierRendu) return;
      if (!window.matchMedia('(max-width: 819px)').matches) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var media = document.querySelector('.main_product_container .image_section');
      if (!media) return;

      var r = media.getBoundingClientRect();
      if (!r.height) return;

      var entete = document.querySelector('header');
      var hautUtile = entete ? entete.getBoundingClientRect().height : 0;
      var visible = Math.max(0, Math.min(window.innerHeight, r.bottom) - Math.max(hautUtile, r.top));
      if (visible / r.height > 0.5) return;        // deja assez visible

      setTimeout(function () {
        var pos = window.pageYOffset + media.getBoundingClientRect().top - hautUtile - 12;
        window.scrollTo({ top: Math.max(0, pos), behavior: 'smooth' });
      }, 200);
    }

    function rafraichir() {
      peindre();
      var v = resoudre();
      majPrix(v);
      majFormulaire(v);
      majGalerie(v);
      if (bouton) {
        var impossible = !v || !v.dispo;
        bouton.classList.toggle('disabled', impossible);
        bouton.setAttribute('aria-disabled', impossible ? 'true' : 'false');

        /* Le prix dans le bouton : au moment de cliquer, l'internaute n'a plus
           a remonter des yeux pour verifier ce qu'il paie. Le libelle est
           recalcule a chaque changement de variante, mais jamais ecrase pendant
           un ajout en cours ou l'affichage de « Ajoute ✓ ». */
        libelleAchat = libelleBase + (v && v.prix ? ' — ' + v.prix : '');
        if (!bouton.dataset.enCours && !bouton.dataset.libelle) bouton.textContent = libelleAchat;
      }
    }

    /* ---------- Compteur du header ----------
       Il est écrit en dur dans aw-header.liquid (« 02 ») et le bundle ne le
       met jamais à jour. On le corrige après un ajout, sinon le seul retour
       visuel serait le libellé du bouton. */
    function majCompteur() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var el = document.querySelector('.cart_button .counter');
          if (el) el.textContent = (c.item_count < 10 ? '0' : '') + c.item_count;
        })
        .catch(function () { /* le compteur reste tel quel : sans conséquence */ });
    }

    /* Le panneau panier volant est court-circuite : le bouton du header est
       desormais un lien direct vers /cart (voir snippets/aw-header.liquid).
       On ne cherche donc plus a l'ouvrir — apres « Ajoute ✓ », le clic suivant
       sur l'icone panier mene a une page reelle au lieu d'un tiroir vide. */

    /* Un seul minuteur pour le libelle du bouton. Il sert a `flash()` et se
       fait annuler par un nouvel ajout : sans cela, le minuteur du message
       precedent viendrait ecraser le « … » de l'ajout en cours. */
    var minuteurLibelle = null;

    function ajouter(e) {
      /* Les deux coupures d'abord, AVANT toute sortie anticipee : meme si l'on
         renonce a ajouter, l'ecouteur d'app.js ne doit pas prendre le relais. */
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!bouton || bouton.dataset.enCours === '1') return;
      var v = resoudre();
      if (!v) return flash('Choisissez une option');
      if (!v.dispo) return flash('Épuisé');

      var q = document.querySelector('#Quantity');
      var quantite = Math.max(1, Number(q && q.value) || 1);

      /* Le verrou ne couvre QUE la requete en vol — le temps ou un second clic
         partirait sans savoir ce que devient le premier. Des la reponse recue,
         le bouton est de nouveau cliquable : « Ajoute ✓ » est un message, pas
         une attente, et quelqu'un qui veut deux exemplaires ne doit pas se
         heurter a un bouton mort pendant que le message s'affiche. */
      clearTimeout(minuteurLibelle);
      delete bouton.dataset.libelle;
      bouton.dataset.enCours = '1';
      bouton.textContent = '…';

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(v.id), quantity: quantite })
      })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw new Error(j && j.description ? j.description : 'Ajout refusé');
            return j;
          });
        })
        .then(function () {
          delete bouton.dataset.enCours;
          majCompteur();
          flash('Ajouté ✓');
        })
        .catch(function (err) {
          delete bouton.dataset.enCours;
          flash(err.message || 'Ajout refusé');
        });
    }

    function flash(message) {
      if (!bouton) return;
      clearTimeout(minuteurLibelle);
      bouton.dataset.libelle = '1';           // empeche rafraichir() d'ecraser le message
      bouton.textContent = message;
      minuteurLibelle = setTimeout(function () {
        delete bouton.dataset.libelle;
        bouton.textContent = libelleAchat;
      }, 1800);
    }

    /* ---------- Branchements ---------- */
    groupes.forEach(function (groupe, g) {
      groupe.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('.variant_button') : null;
        if (!b || !groupe.contains(b)) return;
        // Le grisage doit tenir au clic, pas seulement à l'œil : app.css pose
        // `pointer-events: none` sur .disabled, ce qui n'arrête ni le clavier
        // ni un clic programmatique.
        if (b.classList.contains('disabled')) return;
        selection[g] = b.dataset.value;
        reparer(g + 1);
        rafraichir();
      });
    });

    /* ---------- Clavier : motif radiogroup ----------
       Tab entre dans le groupe sur la valeur cochee, les fleches parcourent
       les valeurs PROPOSABLES uniquement — on ne fait pas atterrir le focus sur
       une combinaison impossible. Espace et Entree valident, comme un vrai
       bouton radio. */
    groupes.forEach(function (groupe, g) {
      groupe.addEventListener('keydown', function (e) {
        var b = e.target.closest ? e.target.closest('.variant_button') : null;
        if (!b || !groupe.contains(b)) return;

        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          b.click();
          return;
        }

        var sens = 0;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') sens = 1;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') sens = -1;
        if (!sens) return;
        e.preventDefault();

        var libres = boutonsDe(g).filter(function (x) { return !x.classList.contains('disabled'); });
        var i = libres.indexOf(b);
        if (i < 0) return;
        var suivant = libres[(i + sens + libres.length) % libres.length];
        selection[g] = suivant.dataset.value;
        reparer(g + 1);
        rafraichir();
        suivant.focus();
      });
    });

    /* ---------- Navigation de la galerie : un seul proprietaire ----------
       Fleches et vignettes sont reprises ici. On ecoute en phase de CAPTURE sur
       `.image_section`, donc AVANT les ecouteurs d'app.js poses sur les noeuds
       eux-memes, et on coupe la serie. Deux raisons a cette reprise :
         — le compteur d'app.js est inaccessible, et le laisser desynchronise
           ferait reculer la galerie au premier clic sur une fleche apres un
           changement de variante (voir l'en-tete) ;
         — `carouselSlide()` scrolle la page vers la galerie, ce qui n'a pas de
           sens quand on clique une vignette que l'on est deja en train de
           regarder.
       La capture est indispensable : le `.nav` est CREE par app.js en fin de
       chargement, on ne peut pas s'abonner a des boutons qui n'existent pas
       encore. Un ecouteur delegue sur un ancetre stable les attrape tous.
       On ne touche PAS au clic sur `.item` : c'est lui qui ouvre le zoom, il
       reste a app.js. */
    var section = document.querySelector('.main_product_container .image_section');
    if (galerie && section) {
      section.addEventListener('click', function (e) {
        var cible = e.target.closest ? e.target : null;
        if (!cible) return;
        var vignette = cible.closest('.thumb_item');
        var prev = cible.closest('.nav .prev');
        var next = cible.closest('.nav .next');
        if (!vignette && !prev && !next) return;   // zoom, image, reste : pas a nous

        e.preventDefault();
        e.stopImmediatePropagation();

        var rang = rangGalerie < 0 ? 0 : rangGalerie;
        if (vignette) {
          rang = Number(vignette.dataset.id);
        } else if (next) {
          rang = rang < galerie.total - 1 ? rang + 1 : 0;        // bouclage, comme app.js
        } else {
          rang = rang > 0 ? rang - 1 : galerie.total - 1;
        }
        if (isNaN(rang)) return;
        rangGalerie = rang;
        galerie.aller(rang);
      }, true);
    }

    /* Lien « Quelle taille choisir ? » : le guide des tailles est plus bas dans
       la page, on y va en douceur plutot que de telelporter le lecteur. */
    var versTailles = document.querySelector('[data-awv2-vers-tailles]');
    if (versTailles) {
      versTailles.addEventListener('click', function (e) {
        var cible = document.querySelector('.awv2-taille');
        if (!cible) return;               // section absente du gabarit : le lien ne fait rien
        e.preventDefault();
        var doux = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        cible.scrollIntoView({ behavior: doux ? 'smooth' : 'auto', block: 'start' });
      });
    }

    if (bouton) {
      /* NEUTRALISATION DE L'ECOUTEUR DU BUNDLE — par ordre d'enregistrement.

         Ce fichier est charge en `defer` dans le <head>, app.js en `defer` en
         fin de <body>. Les scripts differes s'executent dans l'ordre du
         document : NOTRE ecouteur est donc enregistre EN PREMIER. Sur un meme
         noeud, les ecouteurs partent dans l'ordre d'enregistrement, et
         stopImmediatePropagation() interrompt la serie — celui d'app.js n'est
         jamais appele.

         La version precedente clonait le bouton pour « detacher » l'ecouteur du
         bundle. Elle faisait l'inverse de ce qu'on croyait : au moment du
         clonage, app.js n'avait pas encore pose son ecouteur. Il le posait
         ensuite sur le clone, et les deux gestionnaires ajoutaient au panier —
         un clic, deux articles. Le defaut n'est apparu qu'en production, parce
         que sur le dev le gestionnaire du bundle mourait avant d'ajouter. */
      bouton.addEventListener('click', ajouter);
    }

    /* État de départ : on aligne l'affichage sur la variante que Shopify a
       réellement chargée dans le formulaire, au lieu de laisser un formulaire
       vierge en face d'un prix minimum catalogue. */
    var depart = null;
    var cache = document.querySelector('#variant_id');
    if (cache && cache.value) {
      depart = variantes.filter(function (v) { return v.id === String(cache.value); })[0] || null;
    }
    if (!depart) depart = variantes.filter(function (v) { return v.dispo; })[0] || null;
    if (depart) for (var i = 0; i < nb; i++) selection[i] = depart.o[i];
    reparer(0);
    rafraichir();

    /* app.js s'initialise APRES nous — notre script est en `defer` dans le
       <head>, le bundle en `defer` en fin de <body> — et il pose `active` sur la
       premiere vignette. Sans ce rappel, la fiche s'ouvre avec DEUX vignettes
       actives : la sienne et la notre. On repasse donc une fois le chargement
       termine, quand tout le monde a fini de s'installer. */
    window.addEventListener('load', function () {
      majGalerie(resoudre());
      /* Le verrou ne tombe qu'ICI, et pas apres le `rafraichir()` d'init : ce
         rappel-la peut encore changer le rang de la galerie, et il ne doit pas
         non plus faire sauter la page. A partir de maintenant, tout changement
         de rang vient d'un geste de l'internaute. */
      premierRendu = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
